import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
// @ts-expect-error: Unchecked type import
import authService from "@/components/authorization/AuthorizeService";
import { IUser } from "@/services/useProfile";

interface AuthContextType {
  user: IUser | any | null;
  isAuthenticated: boolean;
  refreshAuth: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<IUser | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const refreshAuth = async () => {
    const auth = await authService.isAuthenticated();
    setIsAuthenticated(auth);

    const userData = await authService.getUser();
    setUser(userData);
    setLoading(false);
  };

  useEffect(() => {
    refreshAuth();
  }, []);

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
